import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'benefits';
var loaded = loadState(STORE_KEY) || [];

const state = {
	selectedBenefits: loaded.selectedBenefits || [],
	selectedLiabilities: loaded.selectedLiabilities || [],
	selectedExcess: loaded.selectedExcess || [],
	currentBenefitSelected: null,
};

const mutations = {
	SET_SELECTED_BENEFITS(state, benefit) {
		state.selectedBenefits.push({
			limit: benefit.limit,
			benefit: benefit.benefit,
		});
		saveState(STORE_KEY, state);
	},

	SET_CURRENT_BENEFIT(state, benefit) {
		state.currentBenefitSelected = benefit;
		saveState(STORE_KEY, state);
	},

	REMOVE_SELECTED_BENEFIT(state, benefitId) {
		state.selectedBenefits = state.selectedBenefits.filter(
			(b) => b.benefit.benefitSystemRef !== benefitId,
		);
		saveState(STORE_KEY, state);
	},

	UPDATE_SELECTED_BENEFIT(state, updatedBenefit) {
		let found = false;

		state.selectedBenefits = state.selectedBenefits.map((b) => {
			if (
				b.benefit.benefitSystemRef ===
				updatedBenefit.benefit.benefitSystemRef
			) {
				found = true;
				return {
					limit: updatedBenefit.limit,
					benefit: updatedBenefit.benefit,
				};
			}
			return b;
		});

		if (!found) {
			state.selectedBenefits.push({
				limit: updatedBenefit.limit,
				benefit: updatedBenefit.benefit,
			});
		}

		saveState(STORE_KEY, state);
	},
	SET_SELECTED_EXCESS(state, excess) {
		state.selectedExcess.push(excess);
		saveState(STORE_KEY, state);
	},
	UPDATE_SELECTED_EXCESS(state, updatedExcess) {
		let found = false;

		state.selectedExcess = state.selectedExcess.map((e) => {
			if (e.label === updatedExcess.label) {
				found = true;
				return updatedExcess;
			}
			return e;
		});

		if (!found) {
			state.selectedExcess.push(updatedExcess);
		}

		saveState(STORE_KEY, state);
	},
	REMOVE_SELECTED_EXCESS(state, excessId) {
		state.selectedExcess = state.selectedExcess.filter(
			(e) => e.label !== excessId,
		);
		saveState(STORE_KEY, state);
	},
	SET_SELECTED_LIABILITY(state, liability) {
		state.selectedLiabilities.push({
			limit: liability.limit,
			liability: liability.data,
		});
		saveState(STORE_KEY, state);
	},

	REMOVE_SELECTED_LIABILITY(state, liabilityId) {
		state.selectedLiabilities = state.selectedLiabilities.filter(
			(l) => l.liability.name !== liabilityId,
		);
		saveState(STORE_KEY, state);
	},

	UPDATE_SELECTED_LIABILITY(state, updatedLiability) {
		let found = false;

		state.selectedLiabilitiess = state.selectedLiabilities.map((l) => {
			if (l.liability.name === updatedLiability.liability.name) {
				found = true;
				return {
					limit: updatedBenefit.limit,
					liability: updatedBenefit.data,
				};
			}
			return b;
		});

		if (!found) {
			state.selectedLiabilities.push({
				limit: updatedLiability.limit,
				liability: updatedBenefit.data,
			});
		}

		saveState(STORE_KEY, state);
	},
	CLEAR_BENEFITS_DATA(state) {
		state.selectedBenefits = [];
		state.currentBenefitSelected = null;
		saveState(STORE_KEY, state);
		state.selectedLiabilities = [];
	},
};

const actions = {
	setBenefitsData({ commit }, benefit) {
		commit('SET_SELECTED_BENEFITS', benefit);
	},
	setSelectedBenefit({ commit }, benefit) {
		commit('SET_CURRENT_BENEFIT', benefit);
	},
	removeBenefit({ commit }, benefitId) {
		commit('REMOVE_SELECTED_BENEFIT', benefitId);
	},
	updateSelectedBenefit({ commit }, updatedBenefit) {
		commit('UPDATE_SELECTED_BENEFIT', updatedBenefit);
	},
	setSelectedExcess({ commit }, excess) {
		commit('SET_SELECTED_EXCESS', excess);
	},
	updateSelectedExcess({ commit }, excess) {
		commit('UPDATE_SELECTED_EXCESS', excess);
	},
	removeExcess({ commit }, excessId) {
		commit('REMOVE_SELECTED_EXCESS', excessId);
	},
	setLiabilityData({ commit }, liability) {
		commit('SET_SELECTED_LIABILITY', liability);
	},
	removeLiability({ commit }, liabilityId) {
		commit('REMOVE_SELECTED_LIABILITY', liabilityId);
	},
	updateSelectedLiability({ commit }, updatedLiability) {
		commit('UPDATE_SELECTED_LIABILITY', updatedLiability);
	},
	clearBenefitsData({ commit }) {
		commit('CLEAR_BENEFITS_DATA');
	},
};

const getters = {
	selectedBenefits: (state) => state.selectedBenefits,
	currentBenefit: (state) => state.currentBenefitSelected,
	selectedLiabilities: (state) => state.selectedLiabilities,
	selectedExcesses: (state) => state.selectedExcess,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
